export default [
    {
        name: 'Title', 
        value: 'title'
    }, 
    {
        name: 'Due Date',
        value: 'dueDate',
        date: true,
        utc: true
    },
    {
        name: 'Last modified',
        value: 'modifiedBy'
    },
    {
        name: 'Modified',
        value: 'updatedAt',
        datetime: true,
        utc: true
    }
]